import { render, staticRenderFns } from "./paxByFlight.vue?vue&type=template&id=1684f0b9&scoped=true&"
import script from "./paxByFlight.vue?vue&type=script&lang=js&"
export * from "./paxByFlight.vue?vue&type=script&lang=js&"
import style0 from "./paxByFlight.vue?vue&type=style&index=0&id=1684f0b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684f0b9",
  null
  
)

export default component.exports